import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class PrimeraB2021 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 1046; i <= 1076; i++) {
             if(i != 1055 ){
        	id_list.push(i);
		}
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	        kits:[],
        kit_path: '/images/kits/todas/',
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'vial', 'rivalName':'Fernández Vial', 'pj':30, 'pg':11,'pe':7,'pp':12,'gf':45,'gc':39,'dif':6, 'pts':40},
              {'color':'#ffa500','shortname':'copiapo', 'rivalName':'Dep. Copiapó', 'pj':30, 'pg':14,'pe':10,'pp':6,'gf':49,'gc':36,'dif':13, 'pts':52},
              {'color':0,'shortname':'barnechea', 'rivalName':'Barnechea', 'pj':30, 'pg':5,'pe':9,'pp':16,'gf':28,'gc':44,'dif':-16, 'pts':24},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':30, 'pg':7,'pe':12,'pp':11,'gf':32,'gc':37,'dif':-5, 'pts':33},
              {'color':'#295e1e','shortname':'coquimbo', 'rivalName':'Coquimbo U.', 'pj':30, 'pg':14,'pe':13,'pp':3,'gf':42,'gc':22,'dif':20, 'pts':55},
              {'color':0,'shortname':'magallanes', 'rivalName':'Magallanes', 'pj':30, 'pg':9,'pe':14,'pp':7,'gf':38,'gc':34,'dif':4, 'pts':41},
              {'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':30, 'pg':8,'pe':9,'pp':12,'gf':35,'gc':38,'dif':-3, 'pts':33},
              {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':30, 'pg':9,'pe':8,'pp':13,'gf':34,'gc':42,'dif':-8, 'pts':35},
              {'color':'#ff3355','shortname':'arica', 'rivalName':'San Marcos Arica', 'pj':30, 'pg':3,'pe':7,'pp':19,'gf':11,'gc':60,'dif':-49, 'pts':16},
              {'color':'#ffa500','shortname':'morning', 'rivalName':'S. Morning', 'pj':30, 'pg':13,'pe':12,'pp':5,'gf':43,'gc':26,'dif':17, 'pts':51},
              {'color':0,'shortname':'sanluis', 'rivalName':'San Luis', 'pj':30, 'pg':9,'pe':13,'pp':8,'gf':33,'gc':32,'dif':1, 'pts':40},
              {'color':0,'shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pj':30, 'pg':10,'pe':6,'pp':14,'gf':34,'gc':40,'dif':-6, 'pts':36},
              {'color':'#ffa500','shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':30, 'pg':13,'pe':10,'pp':7,'gf':44,'gc':28,'dif':16, 'pts':49},
              {'color':'#ffa500','shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':30, 'pg':12,'pe':12,'pp':6,'gf':34,'gc':30,'dif':4, 'pts':48},
              {'color':0,'shortname':'santacruz', 'rivalName':'Dep. Santa Cruz', 'pj':30, 'pg':12,'pe':9,'pp':9,'gf':36,'gc':37,'dif':-1, 'pts':45},
              {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':30, 'pg':11,'pe':7,'pp':12,'gf':52,'gc':45,'dif':7, 'pts':40}]
    };
  }

  componentDidMount() {
	this.getKits();
	let newtable2 = this.sortTable(this.state.table2);
                this.setState({table2:newtable2});
	}


getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}

sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
                        aux = table[j+1];
                        table[j+1] = table[j];
                        table[j] = aux;
                } 
             }          
        }
return table;

}




render(){


  let subT = this.subText('#295e1e', 'Asciende a Primera A 2022');
  let subD = this.subText('#ff3355', 'Desciende a Segunda División 2022');
console.log(this.state.id_list);
let subP = this.subText('#ffa500', 'Clasifica a liguilla de ascenso');

  return(

	<div style={{textAlign: 'center' }}>

	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Primera B 2021</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}
	 {subP}
	 {subD}
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Primera B 2021</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Primera B 2021</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Primera B 2021" />
     </div>


  )
}

}
export default PrimeraB2021;
